export default __webpack_public_path__ + "static/hashicorp-1a08bc7b1d5015e0ce39da8784aa0446.png";